import React from 'react';
import { createStyles, makeStyles, styled } from '@mui/styles';
import { Grid, Box, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageProgressState } from './PageProgress.types';

const useStyles = makeStyles((theme) => createStyles({
  container: {
    border: '1px solid #21212114',
    borderRadius: 4,
    padding: theme.spacing(2),
  },
  lineItem: {
    marginTop: theme.spacing(1),
    borderBottom: '1px solid #21212114',
  },
  header: {
    margin: '0',
  },
}));

const StepGrid = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const PageProgress = ({ state }: { state: PageProgressState }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} sx={{
      flexDirection: 'column',
    }}>
      {state.map(({ sectionName, steps }) => (
        <Grid key={sectionName} sx={{
          flex: 1,
        }}>
          <Box className={classes.container}>
            <Grid
              container
              sx={{
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <Grid>
                <h3 className={classes.header}>{sectionName}</h3>
              </Grid>
              {state.length > 1 ? (
                <Grid style={{ color: 'green' }}>
                  <span style={{ color: 'green' }}>
                    <b>{steps.filter((s) => s.progress === 1).length}</b>
                    /
                    {steps.length}
                  </span>
                </Grid>
              ) : null}
            </Grid>
            {steps.map(({
              name,
              description,
              progress,
            }, idx) => (
              <StepGrid key={name} spacing={1} useFlexGap>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    flexDirection: 'row',
                    alignItems: 'space-between',
                    flexWrap: 'nowrap',
                  }}>
                  <Grid container spacing={1}>
                    <Grid>
                      <h4 className={classes.header}>{name}</h4>
                    </Grid>
                  </Grid>
                  {progress === 1 ? (
                    <Grid>
                      <FontAwesomeIcon icon="check" color="green" />
                    </Grid>
                  ) : null}
                </Grid>
                {description ? (
                  <Box>
                    <span>{description}</span>
                  </Box>
                ) : null}
                {idx + 1 !== steps.length ? (
                  <Box>
                    <div className={classes.lineItem} />
                  </Box>
                ) : null}
              </StepGrid>
            ))}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
